import React from 'react';
import FormGroup from 'react-bootstrap/FormGroup';
import FormLabel from 'react-bootstrap/FormLabel';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
const email = (value) => (value && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(value) ? 'Invalid email address' : undefined);

class MultipleEmailInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      emails: props.value || [],
      currentEmail: '',
      currentEmailError: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value && this.props.value !== this.state.emails) {
      this.setState({ emails: this.props.value || [] });
    }
  }

  handleEmailChange = (e) => {
    this.setState({
      currentEmail: e.target.value,
      currentEmailError: null,
    });
  };

  addEmail = () => {
    const { currentEmail, emails } = this.state;
    const { onChange } = this.props;

    if (!currentEmail.trim()) {
      this.setState({ currentEmailError: 'Email address is required' });
      return;
    }

    const emailError = email(currentEmail.trim());
    if (emailError) {
      this.setState({ currentEmailError: emailError });
      return;
    }

    if (emails.includes(currentEmail.trim())) {
      this.setState({ currentEmailError: 'Email address already added' });
      return;
    }

    const newEmails = [...emails, currentEmail.trim()];
    this.setState({
      emails: newEmails,
      currentEmail: '',
      currentEmailError: null,
    });

    if (onChange) {
      onChange(newEmails);
    }
  };

  removeEmail = (emailToRemove) => {
    const { emails } = this.state;
    const { onChange } = this.props;

    const newEmails = emails.filter((email) => email !== emailToRemove);
    this.setState({ emails: newEmails });

    if (onChange) {
      onChange(newEmails);
    }
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.addEmail();
    }
  };

  render() {
    const { label, placeholder = 'Enter email address', disabled = false } = this.props;
    const { emails, currentEmail, currentEmailError } = this.state;

    return (
      <FormGroup>
        {label && <FormLabel>{label}</FormLabel>}

        <div className="d-flex">
          <FormControl
            type="email"
            value={currentEmail}
            onChange={this.handleEmailChange}
            onKeyPress={this.handleKeyPress}
            placeholder={placeholder}
            disabled={disabled}
            className={currentEmailError ? 'is-invalid' : ''}
          />
          <Button variant="outline-primary" onClick={this.addEmail} disabled={disabled} className="ml-2" style={{ minWidth: '60px' }}>
            Add
          </Button>
        </div>

        {currentEmailError && <small className="form-text text-danger">{currentEmailError}</small>}

        {emails.length > 0 && (
          <div className="mt-2">
            {emails.map((email, index) => (
              <div key={index} className="d-flex align-items-center mb-1">
                <span className="badge badge-secondary mr-2 flex-grow-1 text-left">{email}</span>
                <Button variant="outline-danger" size="sm" onClick={() => this.removeEmail(email)} disabled={disabled} style={{ minWidth: '70px' }}>
                  Remove
                </Button>
              </div>
            ))}
          </div>
        )}
      </FormGroup>
    );
  }
}

export default MultipleEmailInput;
